import { parseCivilDate } from './date';

const CIVIL_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export function parseBoolean(value: any): boolean | null {
  if (value === true || value === false) return value;
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
}

export function parseDate(value: any): Date | null {
  if (!value) return null;
  if (value instanceof Date) return value;

  if (typeof value === 'string' && CIVIL_DATE_REGEX.test(value)) {
    return parseCivilDate(value);
  }

  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
}

export function parseNumber(value: any): number {
  if (typeof value === 'number') return value;
  const parsed = parseInt(value);
  return isNaN(parsed) ? 0 : parsed;
}

export function parseString(value: any): string {
  return value ?? '';
}
